type Config = {
  API_KEY: string | null
  API_HOST: string | null
  THEME: string | null
  VECTOR_SOURCE: string | null
}

const config: Config = {
  API_KEY: null,
  API_HOST: 'api.nextbillion.io',
  THEME: null,
  VECTOR_SOURCE: null,
}

export default config
